import { AsyncPipe } from '@angular/common';
import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  output,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'invoice-data',
  templateUrl: './invoice-data.component.html',
  styleUrls: ['./invoice-data.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TranslateModule, AsyncPipe],
})
export class InvoiceDataComponent implements OnInit {
  columnData: Observable<any> = new BehaviorSubject(null);
  readonly onAction = output<{ action: string; columnData: string }>();

  showInvoice: boolean = false;
  invoiceDetails: any;
  constructor() {}

  ngOnInit(): void {}

  OpenInvoiceDetails(invoiceNumber: string) {
    this.onAction.emit({ action: 'openinvoice', columnData: invoiceNumber });
  }
}
